module.exports = __webpack_public_path__ + "static/media/jcb.a01fe9c2.svg";